import { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import { Slider, Rail, Handles } from 'react-compound-slider';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const sliderStyle = {
  marginTop: '20px',
  position: 'relative',
  width: '100%',
  height: '14px',
};

const RangeSlider = ({
  minRange, maxRange, handleRangeChange, hasBigScreenDesign,
}) => {
  const [rangeValue, setRangeValue] = useState([minRange, maxRange]);

  useEffect(() => {
    setRangeValue([minRange, maxRange]);
  }, [minRange, maxRange]);

  const onUpdate = (update) => {
    setRangeValue(update);
  };
  const onChange = (values) => {
    handleRangeChange(values);
  };

  return (
    <div className={cx('range_slider_holder', { big_screen: hasBigScreenDesign })}>
      <div className={Styles.range_value}>
        <div>
          {rangeValue[0] > 0 ? `+${rangeValue[0]}` : rangeValue[0]}
          %
        </div>
        <div>
          {rangeValue[1] > 0 ? `+${rangeValue[1]}` : rangeValue[1]}
          %
        </div>
      </div>
      <Slider
        rootStyle={sliderStyle}
        domain={[-100, 100]}
        values={rangeValue}
        step={1}
        onUpdate={onUpdate}
        onChange={onChange}
      >
        <Rail>
          {({ getRailProps }) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <div className={Styles.range_rail} {...getRailProps()} />
          )}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
      </Slider>
      <div className={Styles.range_label}>
        <div>Very Negative</div>
        <div>Very Positive</div>
      </div>
    </div>
  );
};

export const Handle = ({
  handle: { id, percent },
  getHandleProps,
}) => (
  <div
    className={Styles.range_handle}
    style={{
      left: `${percent}%`,
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...getHandleProps(id)}
  />
);

export default RangeSlider;
